import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { tenantColumns, tenantColumnsOverride } from './columnsMapping';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({}) => {
  return {
    config_columns: {
      [SERVICE_PROVIDERS.SPIREON]: () => tenantColumns.columns[SERVICE_PROVIDERS.SPIREON],
      default: () => tenantColumns.columns['default'],
    },
    config_engineSpeed: {
      [SERVICE_PROVIDERS.SPIREON]: () => false,
      default: () => true,
    },
    getDriverStatusUpdate: {
      [SERVICE_PROVIDERS.SPIREON]: () => true,
      [SERVICE_PROVIDERS.RADIUS]: () => true,
      [SERVICE_PROVIDERS.NAUTO]: () => true,
      [SERVICE_PROVIDERS.TTS]: () => true,
      default: () => false,
    },
    override_columns: {
      [SERVICE_PROVIDERS.SPIREON]: () => tenantColumnsOverride.columns[SERVICE_PROVIDERS.SPIREON],
      [SERVICE_PROVIDERS.RISK_THEORY]: () => tenantColumnsOverride.columns[SERVICE_PROVIDERS.RISK_THEORY],
      default: () => tenantColumnsOverride.columns['default'],
    },
    override_eldState: {
      [SERVICE_PROVIDERS.NAUTO]: () => true,
      [SERVICE_PROVIDERS.RADIUS]: () => true,
      [SERVICE_PROVIDERS.TTS]: () => true,
      default: () => false,
    },
    override_GoogleMap: {
      [SERVICE_PROVIDERS.RADIUS]: () => false,
      [SERVICE_PROVIDERS.NAUTO]: () => false,
      [SERVICE_PROVIDERS.TTS]: () => false,
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    comp_generateRows_Link: {
      [SERVICE_PROVIDERS.SPIREON]: () => false,
      default: () => true,
    },
    comp_generateRows_eld: {
      [SERVICE_PROVIDERS.SPIREON]: () => true,
      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
